import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../../../common/shared.module';
import { HealthInsuredService } from '../../../services/health.insured.service';
import HealthInsured from '../../../../../core/data/models/health.insured.model';

@Component({
  selector: 'app-insured-step',
  imports: [NgClass, FormsModule, SharedModule],
  providers: [HealthInsuredService],
  templateUrl: './insured-step.component.html',
  styleUrl: './insured-step.component.css',
})
export class InsuredStepComponent {
  @Output() onInsuredSelected = new EventEmitter<HealthInsured>();
  @Output() onGoBack = new EventEmitter<void>();
  @Output() nextStep = new EventEmitter<void>();

  @Input() showBackButton = true;
  filteredList: HealthInsured[] = [];
  searchTerm: string = '';
  insuredSelected: HealthInsured | null = null;
  indexSelected: number = -1;

  private _insuredList: HealthInsured[] = [];

  get insuredList(): HealthInsured[] {
    return this._insuredList;
  }

  @Input() set insuredList(value: HealthInsured[] | undefined) {
    this._insuredList = value || [];
    this.filterInsuredList();
  }

  @Input() set value(insured: HealthInsured | null) {
    this.insuredSelected = insured;
  }

  selectInsured(insured: HealthInsured, index: number) {
    this.indexSelected = index;
    this.onInsuredSelected.emit(insured);
  }

  goBack() {
    this.onGoBack.emit();
  }

  goNext() {
    this.nextStep.emit();
  }

  filterInsuredList() {
    const term = this.searchTerm.toLowerCase().trim();
    this.filteredList = this.insuredList.filter((insured) =>
      insured.name.toLowerCase().includes(term),
    );

    if (
      this.indexSelected !== -1 &&
      !this.filteredList.includes(this.insuredSelected!)
    ) {
      this.indexSelected = -1;
      this.insuredSelected = null;
    }
  }
}
